import './styles/__all__.scss';

import 'mobx-react-lite/batchingForReactDom';

import React from 'react';
import ReactDOM from 'react-dom';
import { routerStore } from './lib/components';
import Root from './Root';
import '@progress/kendo-ui';
import '@progress/kendo-ui/js/kendo.timezones.min.js'
import "@progress/kendo-ui/css/web/kendo.common.min.css";
import "@progress/kendo-ui/css/web/kendo.default.min.css";
import "animate.css"
import i18nInit from 'i18n-init';
import packageJson from "../package.json";
import { getI18n } from 'react-i18next';
import { addKendoLocale } from './lib/helpers';

async function main() {
    let cultureName = localStorage.getItem("Culture");
    if (!cultureName) {
        // by defult lang should be ru-RU
        cultureName = "ru-RU";
        localStorage.setItem("Culture", cultureName);
    }

    await i18nInit(cultureName, packageJson.version);
    const i18n = getI18n();
    document.documentElement.lang = i18n.language;
    addKendoLocale(i18n);

    ReactDOM.render(<Root />, document.getElementById('root'));
}

main();